import { render, staticRenderFns } from "./CompanyTablePage.vue?vue&type=template&id=6c7a1e14&scoped=true"
import script from "./CompanyTablePage.vue?vue&type=script&lang=js"
export * from "./CompanyTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7a1e14",
  null
  
)

export default component.exports